export default "__VITE_ASSET__BEsiRHVU__"